<template>
  <q-layout view="lHh lpr lfr">
    <q-header elevated class="glossy">
      <q-toolbar>
        <q-fab color="accent" glossy icon="menu" direction="down">
          <q-fab-action
            v-if="logged_in"
            external-label
            color="accent"
            text-color="white"
            icon="close"
            label="logout"
            @click="onClick('logout')"
          />
        </q-fab>

        <q-toolbar-title>
          Laudomat - Frases
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <router-view v-if="logged_in" v-bind:current-uid="currentUID" />
      <q-page v-else-if="logged_out" class="flex flex-center">
        <div class="q-px-sm q-py-lg">
          <q-btn
            color="accent"
            icon="exit_to_app"
            @click="onClick('login')"
            label="Login"
          />
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import firebase from "@/firebase";

export default {
  name: "LayoutDefault",

  data: function() {
    return {
      currentUID: "UNKNOWN"
    };
  },

  computed: {
    logged_in: function() {
      const currentUID = this.currentUID;
      return currentUID && currentUID !== "UNKNOWN";
    },

    logged_out: function() {
      const currentUID = this.currentUID;
      return currentUID === null;
    }
  },

  methods: {
    onClick: function(name) {
      if (name === "login") {
        firebase
          .auth()
          .signInWithRedirect(new firebase.auth.GoogleAuthProvider());
      } else if (name === "logout") {
        firebase.auth().signOut();
      } else {
        throw `Unknown onClick source name: ${name}`;
      }
    },

    auth_state_listener: function(user) {
      if (user && this.currentUID === user.uid) return;

      if (user) {
        this.currentUID = user.uid;

        // Hacky way to log ID token to the console
        firebase
          .auth()
          .currentUser.getIdToken()
          .then(token => {
            console.log("Firebase auth ID token:");
            console.log(token);
          });
      } else {
        this.currentUID = null;
      }
    },

    auth_redirect_error: function(error) {
      console.error(error);
    }
  },

  mounted: function() {
    firebase.auth().onAuthStateChanged(this.auth_state_listener);
    firebase
      .auth()
      .getRedirectResult()
      .catch(this.auth_redirect_error);
  }
};
</script>

<style></style>
